import { api, type ApiResponse } from '@/lib/api';
import type { GamificationMeResponse, RankingQuery, RankingResponse } from '@troia-v3/types';

/** Cliente HTTP do ranking (`/api/gamification/ranking` e `/api/gamification/me`) — app+auth, todo vendedor com CRM. */
export const rankingApi = {
  async getRanking(query: RankingQuery): Promise<RankingResponse> {
    const res = await api.get<ApiResponse<RankingResponse>>('/gamification/ranking', { params: query });
    return res.data.data!;
  },
  async getMe(): Promise<GamificationMeResponse> {
    const res = await api.get<ApiResponse<GamificationMeResponse>>('/gamification/me');
    return res.data.data!;
  },
};
